import React from 'react';
export function SketchyProductsSection() {
  const scamCards = [{
    title: 'Wild health claims',
    scamExample: '"Prevents cancer," "Cures disease"',
    reality: 'Stickers can\'t cure anything. They can only reduce exposure. Legitimate claim: "Measurably reduces EMF radiation by X%"'
  }, {
    title: 'Pseudoscience terminology',
    scamExample: '"Bio-energy," "frequency alignment," "quantum healing"',
    reality: "These aren't real physics. Legitimate claim: Uses actual physics (absorption, dissipation)"
  }, {
    title: 'No third-party testing',
    scamExample: '"Thousands say it works!"',
    reality: '"Independent lab testing shows X% reduction"'
  }, {
    title: 'Impossible mechanism',
    scamExample: '"Blocks radiation from entering your body"',
    reality: '"Absorbs radiation and dissipates as heat"'
  }, {
    title: 'No refund policy',
    scamExample: '"No refunds, buyer beware"',
    reality: '"90-day money-back guarantee"'
  }];
  const sciencePoints = ['EMF exposure is real — Wireless devices DO emit radiation. This is not controversial. The FCC measures and regulates it.', "EMF at current regulatory levels is not proven to cause cancer — The scientific consensus (WHO, American Cancer Society) is that EMF at current exposure levels doesn't cause cancer. This is important.", "But we don't fully understand non-thermal effects — EMF can affect biological systems at levels below where heat is generated. Research is ongoing. Some studies suggest impacts on sleep, stress hormones, cellular function. Other studies show no effect. Science is genuinely uncertain.", "So precaution is reasonable — Given incomplete knowledge, reducing unnecessary exposure is a rational choice. This is the 'Precautionary Principle.' You're not being paranoid; you're being careful.", 'And reduction is measurable — We know that certain materials CAN reduce EMF exposure. This is physics, not magic. EMF shielding is well-established technology used in hospitals, labs, and military applications for decades.'];
  return <section className="w-full bg-white py-8 md:py-12 lg:py-16 px-4 md:px-6 border-t-[3px]" style={{
    borderColor: '#1B4F9E',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  }} data-id="element-150">
      <div className="max-w-5xl mx-auto" data-id="element-151">
        <h2 className="text-[29px] md:text-[34px] lg:text-[43px] font-bold mb-3" style={{
        color: '#1B4F9E'
      }} data-id="element-152">
          WHY EMF PRODUCTS ARE SKETCHY
        </h2>
        <p className="text-[18px] md:text-[21px] lg:text-[24px] font-medium mb-8" style={{
        color: '#1B4F9E'
      }} data-id="element-153">
          And How to Tell Real Ones From Scams
        </p>

        <div className="text-base md:text-lg leading-relaxed space-y-5 mb-8" style={{
        color: '#2C3E50',
        lineHeight: '1.7'
      }} data-id="element-154">
          <p className="font-semibold" data-id="element-155">
            You're right to be skeptical. The EMF protection market IS flooded
            with garbage.
          </p>

          <p data-id="element-156">
            There are products claiming to "cure EMF sensitivity," "reverse
            radiation damage," or "neutralize 5G with harmonic frequencies."
            Pure pseudoscience. Wild nonsense designed to separate you from
            money.
          </p>
        </div>

        {/* Uploaded Image above Scam Spotting Grid */}
        <div className="my-8 flex justify-center" data-id="element-157">
          <img src="https://cdn.magicpatterns.com/uploads/oEV1TmLkvSRAfEuvEtbd65/unnamed_(1).jpg" alt="Verified EMF Stickers comparison" className="w-full rounded-lg shadow-lg" style={{
          boxShadow: '0px 8px 24px rgba(27, 79, 158, 0.12)'
        }} data-id="element-158" />
        </div>

        {/* Scam Spotting Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-10" data-id="element-159">
          {scamCards.map((card, index) => <div key={index} className="relative p-6 rounded-lg border-2" style={{
          backgroundColor: '#F8F9FA',
          borderColor: '#E67E22'
        }} data-id="element-160">
              <span className="absolute top-3 left-3 px-2 py-1 text-xs font-semibold text-white rounded" style={{
            backgroundColor: '#E67E22'
          }} data-id="element-161">
                SCAM
              </span>
              <h4 className="text-base font-semibold mt-2 mb-3" style={{
            color: '#E67E22'
          }} data-id="element-162">
                {card.title}
              </h4>
              <p className="text-sm mb-2" style={{
            color: '#2C3E50'
          }} data-id="element-163">
                <strong data-id="element-164">Scam Example:</strong> {card.scamExample}
              </p>
              <p className="text-sm" style={{
            color: '#2C3E50'
          }} data-id="element-165">
                <strong data-id="element-166">Reality:</strong> {card.reality}
              </p>
            </div>)}
        </div>

        {/* Scam vs Legitimate Image */}
        <div className="my-10" data-id="element-167">
          
        </div>

        {/* Science Section */}

        {/* Honest Bottom Line */}
        
      </div>
    </section>;
}